import { resurrect } from 'nmr-processing';
import { generateSpectrumFromRanges } from './ranges/generateSpectrumFromRanges';
export function generateSpectrumFromPublicationString(publicationString, usedColors) {
    const { ranges, experiment: { nucleus, solvent }, parts, } = resurrect(publicationString);
    return generateSpectrumFromRanges(ranges, { nucleus, solvent, name: parts[0] }, usedColors);
}
